import { captureException } from '@sentry/react'
import { type UseQueryOptions, useQuery } from '@tanstack/react-query'
import { httpGetPhotoset } from '@/features/photoset/http/photoset.http'
import { Photoset, type PhotosetURLParams } from '@/features/photoset/types'
import { parseAxiosPromise } from '@/helpers/utils'
import { QUERY_KEYS } from '@/query-client'

export const useGetPhotoset = (
	urlParams: PhotosetURLParams,
	options?: Omit<UseQueryOptions<Photoset>, 'queryFn' | 'queryKey'>
) =>
	useQuery({
		...options,
		queryKey: [QUERY_KEYS.PHOTOSET, urlParams],
		queryFn: () =>
			parseAxiosPromise({
				axiosPromise: httpGetPhotoset({
					urlParams: { id: urlParams.id },
					params: { response_type: 'extended' }
				}),
				responseShape: Photoset,
				onZodError: captureException
			})
	})
